import { createSelector } from "@reduxjs/toolkit"
import type { State } from "../../../types/index"
import { RootState } from "../../"

const select = (state: RootState): State.AlertState => state.notification

export const selectAlert = createSelector(select, (alert) => alert)
export const selectPopupError = createSelector(select, (popupError) => popupError)
